/**
 * Ordering Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import {
    orderingElementSchema,
    type OrderingElementData,
    type OrderingItem,
    type OrderingAnswer,
    normalizeOrderingData,
    createDefaultOrderingItem,
    getCorrectOrder,
    MIN_ITEMS,
    MAX_ITEMS,
} from './schema';
import { OrderingEdit } from './OrderingEdit';
import { OrderingPlayer } from './OrderingPlayer';
import { orderingGrader } from './grader';

// Export types
export {
    orderingElementSchema,
    type OrderingElementData,
    type OrderingItem,
    type OrderingAnswer,
};

// Export helpers
export {
    normalizeOrderingData,
    createDefaultOrderingItem,
    getCorrectOrder,
    MIN_ITEMS,
    MAX_ITEMS,
};

// Export components
export { OrderingEdit };
export { OrderingPlayer };
export { orderingGrader };

export const orderingElement: ElementDefinition<OrderingElementData, OrderingAnswer> = {
    schema: orderingElementSchema,
    EditComponent: OrderingEdit as ElementDefinition<OrderingElementData, OrderingAnswer>['EditComponent'],
    PlayerComponent: OrderingPlayer as ElementDefinition<OrderingElementData, OrderingAnswer>['PlayerComponent'],
    grader: orderingGrader,
    validator: {
        validate: orderingGrader.validate!,
    },
};
